module.exports = __webpack_public_path__ + "img/badge_gray_holistic-finance.366825b8.svg";